jQuery(document).ready(function($) {

    function svg_debug(thenode) {
        console.log('symbols:');
        $(thenode).find("symbol").each(function() {
            console.log("<svg class='icon'><use xlink:href='#" + this.id + "'/></svg>");
        });
    }

    jQuery.get(themepath + "/img/sprites.svg", function(data) {
            $("body").prepend("<div id='svg-inject' style='display: none'>" + new XMLSerializer().serializeToString(data.documentElement) + "</div>")
        })
        .success(function() { svg_debug('#svg-inject') });

});